import { Plus } from 'lucide-react';
import type { NodePath } from '@/components/tree-dnd/tree-dnd-types';
import { useTreeDndStore } from '@/components/tree-dnd/tree-dnd-store';
import { useTreeDndUiStore } from '@/components/tree-dnd/tree-dnd-ui-store';
import { useI18nContext } from '@/i18n/i18n-react';
import { Button } from '@/components/ui/button';

interface TreeDndAddButtonProps {
  parentPath: NodePath;
}

export function TreeDndAddButton({ parentPath }: TreeDndAddButtonProps) {
  const { LL } = useI18nContext();
  const isApplyingAiChanges = useTreeDndStore(
    (state) => state.isApplyingAiChanges
  );
  const requestAddSheet = useTreeDndUiStore((state) => state.requestAddSheet);

  return (
    <div className="flex justify-center pt-1">
      <Button
        type="button"
        variant="outline"
        size="icon"
        className="size-8"
        aria-label={LL.audiences.filters.addNode()}
        disabled={isApplyingAiChanges}
        onClick={() => requestAddSheet(parentPath)}
      >
        <Plus />
      </Button>
    </div>
  );
}
